'use strict';

function showErrorForField ($element, textClass, textMsg) {
  var $parent = $element.parent();
  var $msgContainer = $parent.find('.error-msg');

  if (textClass == null) {
    textClass = 'default';
  }

  if (textMsg == null) {
    textMsg = false;
  }

  if (textClass !== 'suggest') {
    $parent.addClass('error has-error');
  }

  $msgContainer.addClass('visible');
  $msgContainer.find('>span').hide();
  $msgContainer.find('>span.' + textClass).show();

  if (textMsg) {
    return $msgContainer.find('>span.' + textClass).html(textMsg);
  }
}

module.exports = showErrorForField;
